import  { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from '../styles/Navigation.module.css';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'about', 'skills', 'projects', 'experience', 'contact'];
      // Offset for centering the active check
      const scrollPos = window.scrollY + 300; 

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPos >= offsetTop && scrollPos < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLinkClick = (sectionId) => {
    setIsOpen(false);
    setActiveSection(sectionId); // Instant update for better UX
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'experience', label: 'Experience' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <motion.nav 
      className={styles.nav}
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className={styles.nav__container}>
        {/* <a href="#hero" className={styles.nav__logo}>
          Dev.
        </a> */}

        {/* Desktop Links */}
        <ul className={`${styles.nav__links} ${isOpen ? styles.active : ''}`}>
          {navItems.map((item) => (
            <li key={item.id} className={styles.nav__item}>
              <button
                onClick={() => handleLinkClick(item.id)}
                className={styles.nav__link}
                data-active={activeSection === item.id}
                aria-current={activeSection === item.id ? 'page' : undefined}
              >
                {activeSection === item.id && (
                  <motion.span
                    layoutId="activePill"
                    className={styles.active_pill}
                    transition={{ type: "spring", stiffness: 200, damping: 25 }}
                  />
                )}
                <span style={{ position: 'relative', zIndex: 2 }}>
                  {item.label}
                </span>
              </button>
            </li>
          ))}
        </ul>

        <div className={styles.nav__actions}>

          <button
            className={`${styles.nav__toggle} ${isOpen ? styles.active : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={isOpen}
          >
            <span className={styles.nav__toggle_line}></span>
            <span className={styles.nav__toggle_line}></span>
            <span className={styles.nav__toggle_line}></span>
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
